import { FC } from 'react';
import styled from 'styled-components';
import Icon, { IconName } from './Icon';

const Tile = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
  background: ${(p) => p.theme.colors.dashboard.icon};
  color: ${(p) => p.theme.colors.general.primary};
`;

/** A dashboard tile: a square light background with a primary-colour icon, filling its wrapper. */
const IconTile: FC<{ name: IconName }> = ({ name }) => (
  <Tile>
    <Icon name={name} size="50%" />
  </Tile>
);

export default IconTile;
